import axios from 'axios';
import { serverConfig } from '../server-config';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Auth token has expired or is invalid, delete it from local storage
      localStorage.removeItem('authToken');
      location.reload();
    }
    return Promise.reject(error);
  }
);
const convertFileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result.split(",")[1];
      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};
const ClientUserService = {
  addClientUser: (clientUser) => {
    return axios.post(`https://${serverConfig.serverBaseAddress}/signite/client-users/add`, clientUser, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('authToken'),
      },
    });
  },

  getAllClientUsers: (name = "", page = 0, size = 10) => {
    return axios.get(
      `https://${serverConfig.serverBaseAddress}/signite/client-users/get/all`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        params: {
          name,
          page,
          size,
        },
      }
    );
  },

  deactivateClientUser: (username) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-users/deactivate/${username}`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },

  activateClientUser: (username) => {
    return axios.post(
      `https://${serverConfig.serverBaseAddress}/signite/client-users/activate/${username}`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
      }
    );
  },


  downloadFile: (filePath) => {
    return axios({
      method: 'get',
      url: `https://${serverConfig.serverBaseAddress}/signite/file/download?path=${filePath}`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
    });
  },
  getClientDetails: (username) => {
    return axios.get(`https://${serverConfig.serverBaseAddress}/signite/client-users/get/${username}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
    });
  },

  uploadProfilePicture: async (username, file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `https://${serverConfig.serverBaseAddress}/signite/client-users/upload/dp?username=${username}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error uploading profile picture:", error.response?.data || error.message);
      throw error;
    }
  },
  
  uploadClientPrimaryDocs: async (clientId, file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `https://${serverConfig.serverBaseAddress}/signite/client/upload/doc?clientId=${clientId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error uploading docs:", error.response?.data || error.message);
      throw error;
    }
  },

  uploadClientDocs: async (username, file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `https://${serverConfig.serverBaseAddress}/signite/client-users/upload/doc?username=${username}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error uploading docs:", error.response?.data || error.message);
      throw error;
    }
  },

  deleteClientFile: async (username, filePath) => {
    try {
      const response = await axios.delete(
        `https://${serverConfig.serverBaseAddress}/signite/client-users/delete/doc?username=${encodeURIComponent(username)}&path=${encodeURIComponent(filePath)}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting file:", error.response?.data || error.message);
      throw error;
    }
  },

  getFileDownloadUrl: (dpPath) => {
    return `${serverConfig.apiBaseUrl}/signite/client-users/download?path=${encodeURIComponent(dpPath)}`;
  },
};

export default ClientUserService;
